export default __webpack_public_path__ + "static/media/ic_san_marino.fa17e43e.svg";